// TA Labels & Badges injects its label into the grid <li>, so bottom-positioned
// labels land at the bottom of the whole card (over the price) instead of the image.
// Move each label into the card's image box so it is positioned against the image.
(function () {
  var selector = '.grid__item > .bss_pl_img';

  function moveLabels() {
    document.querySelectorAll(selector).forEach(function (label) {
      var imageBox = label.parentElement.querySelector('.card__inner');
      if (imageBox) imageBox.appendChild(label);
    });
  }

  function init() {
    moveLabels();
    new MutationObserver(function () {
      if (document.querySelector(selector)) moveLabels();
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
